import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { FiArrowUp, FiArrowDown } from 'react-icons/fi';
import styles from '../DashboardOverviewNew.module.scss';

export const OverallProductivity = ({ data, isLoading = false }) => {
  const { score, label, trendPct, trendUp, teamAvg } = data;
  const gaugeData = [{ value: score }, { value: 100 - score }];

  if (isLoading) {
    return (
      <div
        className={styles.productivityCard}
        style={{ opacity: 0.5, pointerEvents: 'none' }}
      >
        <span className={styles.cardTitle}>Overall Productivity</span>
        <div className={styles.gaugeWrapper} />
      </div>
    );
  }

  return (
    <div className={styles.productivityCard}>
      <span className={styles.cardTitle}>Overall Productivity</span>

      <div className={styles.gaugeRow}>
        <div className={styles.gaugeWrapper}>
          <ResponsiveContainer width="100%" height={110}>
            <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
              <defs>
                <linearGradient id="gaugeGradient" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#4338CA" />
                  <stop offset="100%" stopColor="#818CF8" />
                </linearGradient>
              </defs>
              {/* Track arc */}
              <Pie
                data={[{ value: 100 }]}
                cx="50%"
                cy="80%"
                startAngle={210}
                endAngle={-30}
                innerRadius={64}
                outerRadius={74}
                dataKey="value"
                strokeWidth={0}
              >
                <Cell fill="#EEF2FF" />
              </Pie>
              {/* Score arc */}
              <Pie
                data={gaugeData}
                cx="50%"
                cy="80%"
                startAngle={210}
                endAngle={-30}
                innerRadius={64}
                outerRadius={74}
                dataKey="value"
                strokeWidth={0}
              >
                <Cell fill="url(#gaugeGradient)" />
                <Cell fill="transparent" />
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <div className={styles.gaugeCenter}>
            <div className={styles.gaugeScore}>{score}%</div>
            <div className={styles.gaugeBadge}>{label}</div>
          </div>
        </div>

        <div className={styles.gaugeTrendBlock}>
          <div className={styles.gaugeTrend}>
            {trendUp ? (
              <FiArrowUp size={13} className={styles.gaugeTrendUp} />
            ) : (
              <FiArrowDown size={13} className={styles.gaugeTrendDown} />
            )}
            <span
              className={trendUp ? styles.gaugeTrendUp : styles.gaugeTrendDown}
            >
              {trendPct}%
            </span>
          </div>
          <span className={styles.gaugeTrendVs}>vs yesterday</span>
        </div>
      </div>

      <div className={styles.gaugeTeamAvg}>Team Average: {teamAvg}%</div>
    </div>
  );
};
